const P5SystemVars = [
  'canvas',
  'frameCount',

  'width',
  'height',
  'windowWidth',
  'windowHeight',

  'mouseX',
  'mouseY',
  'winMouseX',
  'winMouseY',
  'pmouseX',
  'pmouseY',
  'pwinMouseX',
  'pwinMouseY',
  'mouseButton',
  'mouseIsPressed',
  'touches',

  'pAccelerationX',
  'pAccelerationY',
  'pAccelerationZ',
  'pRotationX',
  'pRotationY',
  'pRotationZ',
  'pAccelerationX',
  'pAccelerationY',
  'deviceOrientation',
  'turnAxis',

  'key',
  'isKeyPressed',
  'keyIsPressed',
  'keyCode',
];
// P5SystemVars = P5SystemVars.slice(0, 2);

module.exports = P5SystemVars;
